import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import query from "query-string";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

class TicketFail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ""
    };
  }

  componentDidMount() {
    const error = query.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).error;
    this.setState({ error: error });
  }

  render() {
    return (
      <div className="trainsaction-fail">
        <div className="header">Transaction Fail</div>
        <div className="trainsaction-fail-main">
          <Card>
            <CardHeader title="Transaction Error" />
            <CardContent>{this.state.error}</CardContent>
            <CardActions>
              <Button size="large">
                <a href="https://www.confirmtkt.com/bus-booking-phonepe">
                  CANCEL
                </a>
              </Button>
              <Button size="large">
                <a href="https://www.confirmtkt.com/bus-booking-phonepe">
                  RETRY
                </a>
              </Button>
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

export default TicketFail;
